<template>
    <card class="tw-text-center">
        <div class="tw-py-2">
			<stepper-carrusel
				:steps="stages"
				:current-step="currentStep"></stepper-carrusel>
        </div>
    </card>
</template>

<script>
import Card from '@/modules/shared/components/ui/Card/Card';
import stepperCarrusel from '@/modules/shared/components/ui/stepper/stepper-carrusel';
import { mapState } from 'vuex';
import { pathOr, map, applySpec, prop, pipe } from 'ramda';

function created() {
	// const stage = this.$store.state.jobProfile &&
	// 	this.$store.state.jobProfile.mainData &&
	// 	this.$store.state.jobProfile.mainData.config &&
	// 	this.$store.state.jobProfile.mainData.config.stages
	// 	? this.$store.state.jobProfile.mainData.config.stages : [];
	// const current = this.currentStep;
	// if (this.currentStep === current) {
	// 	const index = this.currentStep - 1;
	// 	const objectStep = stage[index];
	// 	this.$emit('code-step', objectStep);
	// }
}

function data() {
	return {
	};
}

function stepClass() {
	return step => ({
		completed: this.stages.indexOf(step) < this.currentStep - 1,
	});
}

export default {
	name: 'model-stepper',
	components: {
		Card,
		stepperCarrusel,
	},
	beforeCreate() {
		this.$store.dispatch('jobProfile/loadJobProfileConfig');
	},
	created,
	beforeMount() {
		const stage = this.$store.state.jobProfile &&
			this.$store.state.jobProfile.mainData &&
			this.$store.state.jobProfile.mainData.config &&
			this.$store.state.jobProfile.mainData.config.stages
			? this.$store.state.jobProfile.mainData.config.stages : [];
		const current = this.currentStep;
		if (this.currentStep === current) {
			const index = this.currentStep - 1;
			const objectStep = stage[index];
			this.$emit('code-step', objectStep);
		}
	},
	data,
	methods: {
	},
	computed: {
		stepClass,
		...mapState('jobProfile', {
			stages: pipe(
				pathOr([], ['mainData', 'config', 'stages']),
				map(
					applySpec({
						code: prop('code'),
						label: prop('title'),
					}),
				),
			),
			stage: pathOr([], ['mainData', 'config', 'stages']),
		}),
	},
	watch: {
		stage: {
			handler(newValue) {
				const current = this.currentStep;
				if (this.currentStep === current) {
					const index = this.currentStep - 1;
					const objectStep = newValue[index];
					this.$emit('code-step', objectStep);
				}
			},
		},
	},
	props: ['currentStep'],
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/job-profile/components/content/model-stepper.vue